module.exports = __webpack_public_path__ + "img/cl_without_goods.384efa15.png";